import { ACTIVE_AUDIO_NODE_STORE } from '../globals';
import { getEventListenersOfAudioNode } from './get-event-listeners-of-audio-node';
export const setInternalState = (audioNode, internalState) => {
    if (internalState === 'active') {
        if (ACTIVE_AUDIO_NODE_STORE.has(audioNode)) {
            throw new Error('The AudioNode is already stored.');
        }
        ACTIVE_AUDIO_NODE_STORE.add(audioNode);
    }
    else {
        if (!ACTIVE_AUDIO_NODE_STORE.has(audioNode)) {
            throw new Error('The AudioNode is not stored.');
        }
        ACTIVE_AUDIO_NODE_STORE.delete(audioNode);
    }
    getEventListenersOfAudioNode(audioNode)
        .forEach((eventListener) => eventListener(internalState));
};
//# sourceMappingURL=/build/es2018/helpers/set-internal-state.js.map